export default {"src":"/_next/static/media/store_not_found_bag.ac1f8504.svg","height":119,"width":130,"blurWidth":0,"blurHeight":0};